// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { useState } from "react"

export const ApiKeyCreatedAlert = ({ apiKey }: { apiKey: string }) => {
  const [copied, setCopied] = useState(false)
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(apiKey)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch (e) {
      setCopied(false)
    }
  }
  return (
    <div className="flex flex-col gap-4">
      <div className="font-bold text-sm">
        Your API key has been created successfully.
      </div>
      <div className="flex items-center gap-1.5 text-[#FF9944] bg-[#2A1100] border border-[#FF9944] rounded-md p-1.5 font-semibold text-sm">
        <span className="text-xl">⚠️</span>
        You will not be able to see it again later. Copy it.
      </div>
      <div className="bg-[#222] rounded-md pl-3 p-1.5 font-mono text-sm word-break-break-all flex items-center gap-4 flex-row justify-between select-text">
        <span>{apiKey}</span>
        <button
          onClick={handleCopy}
          className="bg-[#2C2C2C] border-none text-[#CCC] text-sm px-2 py-1 rounded-md opacity-80 hover-opacity cursor-pointer"
        >
          {copied ? "Copied!" : "Copy key"}
        </button>
      </div>
    </div>
  )
}
